export default "__VITE_ASSET__DrJ_3pKI__"